import React from 'react'
import styled from 'styled-components'

import Container from './Container'
import config from '../config'

import taglineImg from '../images/tagline.png'

const Wrapper = styled.footer`
  background: ${config.colors.gray};
  padding-top: 60px;
  padding-bottom: 80px;
  text-align: center;
  line-height: 1.5;
  position: relative;
  z-index: 998;
`

const Nav = styled.ul`
  margin: 0 0 36px 0;
  padding: 0;
  list-style: none;
  font-size: 16px;
`

const NavItem = styled.li`
  display: inline-block;

  &:not(:last-child)::after {
    content: '|';
    display: inline-block;
    margin: 0 4px 0 6px;
  }
`

const NavButton = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

const Legal = styled.div`
  font-size: 12px;
  max-width: 860px;
  margin: 0 auto;

  a {
    color: inherit;
    text-decoration: underline;
  }

  p {
    margin-bottom: 1em;
  }
`
const Tagline = styled.img`
  display: block;
  height: 72px;
  width: auto;
  margin: 0 auto 46px auto;
  max-width: 100%;
`

const Footer = ({ children }) => (
  <Wrapper>
    <Container>
      <Tagline src={taglineImg} alt="" />
      <Nav>
        <NavItem>
          <NavButton href="https://www.americanexpress.com/de-at/" target="_blank">
            Website
          </NavButton>
        </NavItem>
        <NavItem>
          <NavButton
            href="https://www.americanexpress.com/at/legal/rules.html"
            target="_blank">
            Regeln
          </NavButton>
        </NavItem>
        <NavItem>
          <NavButton
            href="https://www.americanexpress.com/at/legal/trademarks.html"
            target="_blank">
            Warenzeichen
          </NavButton>
        </NavItem>
        <NavItem>
          <NavButton
            href="https://amex-card.at/datenschutz/datenschutzerklaerung.php"
            target="_blank">
            Datenschutz
          </NavButton>
        </NavItem>
        <NavItem>
          <NavButton
            href="https://www.americanexpress.com/at/legal/impressum.html"
            target="_blank">
            Impressum
          </NavButton>
        </NavItem>
        <NavItem>
          <NavButton
            href="https://www.amex-card.at/datenschutz/ueber_cookies.php"
            target="_blank"
          >
            Cookie-Richtlinie
          </NavButton>
        </NavItem>
      </Nav>
      <Legal>
        {children}
        <br />
        <p>
          Copyright © {(new Date().getFullYear())} American Express Company. Alle Rechte vorbehalten.<br />
American Express Europe S.A. - Austrian Branch, Rathausstraße 1, 1010 Wien, Geschäftsleitung Österreich: Anita Pruckner, Klemens Brugner, Firmenbuchnummer: FN 495241 x, UID Nr.: ATU73547502. Zweigniederlassung einer Aktiengesellschaft (Sociedad Anónima) nach spanischem Recht mit Sitz in Madrid. Direktoren/Unternehmensgegenstand: siehe unter  
          <a
          href="https://www.americanexpress.com/at/legal/impressum.html"
          target="_blank"
          rel="noopener noreferrer">
          www.americanexpress.at/impressum
          </a>. Anschrift: Avenida Partenón 12-14, 28042, Madrid, Spanien, eingetragen im Registro Mercantil de la Provincia de Madrid, Hoja M-257407, Tomo 15348, Folio 204.
        </p>
        <p>
          Es gelten die Bedingungen der American Express Website-Regeln und
          -Bestimmungen.
        </p>
      </Legal>
    </Container>
  </Wrapper>
)

export default Footer
